import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Languages } from 'enums/languages';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: Languages.ENGLISH, // Default language fallback
        debug: true, // Enable debug logs

        interpolation: {
            escapeValue: false, // React already escapes values
        },

        backend: {
            loadPath: '/locales/{{lng}}/common.json', // Path to your localization files
        },
    });

export default i18n;